// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1mVSt","content":"Consent_content__2Rc1x","footer":"Consent_footer__1-Jc9"};